module.exports = __webpack_public_path__ + "img/whatsapp-monochrome.9c4ee828.svg";